/* ============================================================================
   SUNNY STRIPES — BOOK NOW (instant quote → Shopify cart)      added 2026-09-01
   ----------------------------------------------------------------------------
   THERE ARE NO PRICES AND NO VARIANT IDS IN THIS FILE.

   It reads the quote the customer just built out of sunny-quote-v19's state (S),
   turns it into SKUs via assets/ss-variants.js, and sends them to Shopify's cart
   permalink. The price they pay is the price Shopify holds for that variant,
   which the catalog generator wrote from ss-rates.js - the same card that priced
   the quote on screen. Three copies of a number, one source.

   WHY A SEPARATE FILE
   sunny-quote-v19.js is minified and hosted on the Files CDN, outside the theme,
   so it cannot be edited at all. ss-instant-quote-rates.js already reaches into
   its globals to correct pricing; this does the same for booking, and stays
   separate so a pricing change and a checkout change never touch one file.

   ----------------------------------------------------------------------------
   WHAT CAN AND CANNOT GO IN A CART

   Bookable - one-time jobs with a product behind them:
     aeration / overseeding, compost topdressing, dethatching, fertilization
     (quantity = the number of applications in the program the customer picked),
     grub control, spring and fall cleanups, shrub trimming. Topdressing plus a
     full aerate+overseed carts as ONE bundle product, already discounted 10%,
     because a cart permalink cannot carry a discount.

   NOT bookable as quoted:
     THE MOWING SEASON. The tool quotes mowing as a season programme with a
     monthly figure, and the store sells a season only in spring. Putting that
     in a cart in September would charge for something other than what was
     quoted. What IS offered is a single FIRST VISIT, opt-in and separately
     labelled: pay for one mow to get started, every visit after it is billed on
     completion, and a full season can be prepaid in spring instead.

     FERTILIZATION, BUT ONLY WHEN MOWING IS ALSO TICKED. The quote takes 10% off
     the fertilization program off the back of the mowing plan, and a cart cannot
     reproduce a discount that is conditional on something it does not sell.
     Carting it anyway would charge $157 over the quote on a half-acre lawn.

     SNOW has no product at all - it is priced per push by driveway size, and
     Carl deliberately does not sell it self-serve.

     MULCH & ROCK are quote-only; the material is the price.

   Everything held back is named on the panel with its reason. Nothing is
   silently dropped from a basket the customer thought they were buying, and if
   nothing is left to sell, the lead form below is the honest path.

   ----------------------------------------------------------------------------
   THE DISCLAIMER IS NOT BOILERPLATE
   These prices come from a satellite measurement and a size band. A gate too
   narrow for the mower, a slope that needs a walk-behind, half the "lawn" turning
   out to be bed - those change the job. The panel says so plainly, and promises
   we ask before charging more. Do not quietly delete it to tighten the layout.
   ============================================================================ */
(function () {
  "use strict";

  var PANEL_ID = "ssBookNow";

  /* Whether the customer has ticked "add my first mow". Module-level because
     render() rebuilds the panel's markup from scratch on every recalculation,
     so the checkbox element itself cannot be where the answer lives. */
  var addFirstMow = false;

  /* Which rate-card service each of the tool's own service keys books as, and
     how many line items it produces. Anything absent from here is not bookable
     and is reported to the customer instead of being silently dropped. */
  function itemsFor(S) {
    var out = [], t = S.lot;

    /* TOPDRESSING AND THE PAIR DISCOUNT.
       Topdressing rides in the tool's "mulch" service slot - see the long note
       in ss-instant-quote-rates.js for why. When it is ticked alongside a full
       aerate+overseed, the quote shows the two at 10% off the pair, and the
       cart cannot express a discount. So the pair is carted as the single
       already-discounted bundle product instead of two lines, which is exactly
       the number on screen. Any other combination carts the services
       separately at full price, which is also exactly the number on screen. */
    var aerMode = (S.svc.aer && S.svc.aer.mode) || "both";
    var topdressOn = on(S, "mulch");
    var pairBundled = topdressOn && on(S, "aer") && aerMode === "both";

    if (pairBundled) {
      out.push({ svc: "topdressAeration", tier: t, qty: 1 });
    } else {
      if (on(S, "aer")) {
        var svc = aerMode === "aerate" ? "aerate" : (aerMode === "seed" ? "overseed" : "aerseed");
        out.push({ svc: svc, tier: t, qty: 1 });
      }
      if (topdressOn) out.push({ svc: "topdress", tier: t, qty: 1 });
    }
    /* Temporary irrigation - an option on the aeration tile, only offered with
       overseeding (see ss-instant-quote-rates.js). Its own line, never
       discounted. Above an acre it has no product and is held back below. */
    if (on(S, "aer") && aerMode !== "aerate" && S.svc.aer.irr && tierArea(t) != null &&
        window.SS_RATES.price("irrigation", tierArea(t)) != null) {
      out.push({ svc: "irrigation", tier: t, qty: 1 });
    }
    if (on(S, "dethatch")) out.push({ svc: "dethatch", tier: t, qty: 1 });
    if (on(S, "grub"))     out.push({ svc: "grub",     tier: t, qty: 1 });
    if (on(S, "shrub"))    out.push({ svc: "shrub",    tier: t, qty: 1 });

    /* Fertilization is sold per application. The tool sells a 3- or 6-step
       program, so the program becomes a quantity rather than a second product -
       which also means the cart line reads "x6" and the customer can see what
       they are buying.

       BUT NOT WHEN THEY ARE ALSO BUYING MOWING. The quote tool takes 10% off
       the fertilization line whenever a mowing plan is selected - a real
       discount, shown to the customer as "Bundle savings". The cart cannot
       reproduce it, because the thing it is conditional on (the mowing plan) is
       not something the cart sells. Carting fert anyway would charge $157 more
       than the screen promised on a half-acre lawn. So when mowing is on, fert
       is held back with it and explained, exactly like mowing itself. */
    if (on(S, "fert") && !on(S, "mow")) {
      var steps = parseInt(S.svc.fert && S.svc.fert.steps, 10);
      if (!(steps > 0)) steps = 1;
      out.push({ svc: "fert", tier: t, qty: steps });
    }

    /* Cleanups are two different products; "both" is two line items, not a
       double quantity of one. */
    if (on(S, "clean")) {
      var w = (S.svc.clean && S.svc.clean.which) || "both";
      if (w === "spring" || w === "both") out.push({ svc: "cleanupSpring", tier: t, qty: 1 });
      if (w === "fall"   || w === "both") out.push({ svc: "cleanupFall",   tier: t, qty: 1 });
    }
    return out;
  }

  /* Services the customer ticked that cannot be carted, each with the reason -
     so the panel says which parts still need us rather than appearing to have
     quietly forgotten them. Every entry here is a promise the cart is unable to
     keep, stated out loud. */
  function heldBack(S) {
    var h = [];
    if (on(S, "mow")) {
      h.push({
        label: "Mowing",
        why: "A mowing plan is a schedule, not a single job — we agree the day of " +
             "the week and the start date with you first."
      });
    }
    if (on(S, "mow") && on(S, "fert")) {
      h.push({
        label: "Fertilization",
        why: "Your quote takes 10% off the fertilization program because you're on a " +
             "mowing plan. That saving rides on the mowing schedule, so the two get set " +
             "up together — we're not going to charge you full price for it here."
      });
    }
    if (on(S, "aer") && ((S.svc.aer.mode || "both") !== "aerate") && S.svc.aer.irr &&
        tierArea(S.lot) != null && window.SS_RATES.price("irrigation", tierArea(S.lot)) == null) {
      h.push({
        label: "Temporary irrigation",
        why: "On a property this size the watering setup depends on how many spigots " +
             "we can run from and how the lawn lies, so we price it after a look."
      });
    }
    if (on(S, "snow")) {
      h.push({
        label: "Snow clearing",
        why: "Snow is a seasonal arrangement, priced per plow by driveway; we set that " +
             "up with you directly."
      });
    }
    return h;
  }

  function on(S, k) { return !!(S.svc && S.svc[k] && S.svc[k].on); }

  /* What the cart will actually come to.
     ------------------------------------------------------------------------
     The panel sits directly under the estimate rail, whose largest number is
     the SEASON total - and that includes mowing, which the cart deliberately
     does not. Saying "the price above" there would point at $1,275 while
     charging $755. So the panel states its own figure outright.

     This recomputes from the rate card rather than scraping the rail, and it
     lands on Shopify's number by construction: the catalog generator wrote
     every variant price as round5(price(service, tierArea)), which is exactly
     what this does. If those two ever disagree the catalog is stale and needs
     re-syncing - see the note at the top of ss-rates.js. */
  function tierArea(k) {
    var t = window.SS_RATES.tiers, i;
    for (i = 0; i < t.length; i++) if (t[i].k === k) return t[i].area;
    return null;
  }

  /* `area`, when given, prices every line at that square footage instead of
     its tier's - used only to ask whether an exact-size quote matches the
     size-band product (see EXACT-SIZE QUOTES in render()). */
  function subtotal(wanted, area) {
    var SS = window.SS_RATES, sum = 0, i, a;
    for (i = 0; i < wanted.length; i++) {
      a = area != null ? area : tierArea(wanted[i].tier);
      if (a == null) return null;
      if (wanted[i].svc === "topdressAeration") {
        /* Same arithmetic as build-products.js: round each service to $5, add,
           then round the discount and subtract it. Rounding the discounted sum
           instead lands $5 out on a Large lawn. */
        var full = SS.round5(SS.price("topdress", a)) + SS.round5(SS.price("aerseed", a));
        sum += (full - SS.round5(full * SS.bundleDiscount)) * wanted[i].qty;
        continue;
      }
      /* Mowing is a per-visit curve rather than a per-1,000 rate, so it does
         not go through price(). The catalog priced SS-MOW-VISIT-* the same
         way - round5(mowPerVisit(acres)) - so these agree by construction. */
      var each = wanted[i].svc === "mow"
        ? SS.mowPerVisit(a / 43560)
        : SS.price(wanted[i].svc, a);
      if (each == null) return null;
      sum += SS.round5(each) * wanted[i].qty;
    }
    return sum;
  }

  function money(n) {
    return "$" + Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  function ready() {
    return typeof S !== "undefined" && S && S.svc &&
           window.SS_VARIANTS && window.SS_RATES &&
           document.getElementById("estTotals");
  }

  function isCustomLot() {
    try { if (typeof isCustom === "function" && isCustom()) return true; } catch (e) {}
    return !S.lot || S.lot === "xx";
  }

  function styles() {
    if (document.getElementById("ssBookNowCss")) return;
    var s = document.createElement("style");
    s.id = "ssBookNowCss";
    /* EVERY MARGIN AND PADDING HERE IS !important, AND THAT IS NOT LAZINESS.
       The panel is injected into the quote tool's own estimate rail, and that
       tool's stylesheet zeroes padding and margin on the divs inside it. The
       first version of this panel looked squashed for exactly that reason - the
       background and border applied, the spacing silently did not, and the
       computed padding read 0px against the 16px asked for. Anything that has
       to survive the host stylesheet is marked; the purely cosmetic properties
       are left normal so they stay easy to override. */
    var P = "#" + PANEL_ID;
    s.textContent =
      P + "{margin:18px 0 16px !important;padding:20px 18px 18px !important;" +
      "border:1.5px solid #E9EEDC;border-left:5px solid #A0C537;border-radius:13px;" +
      "background:#F6F4EC;font-family:'Assistant',Helvetica,Arial,sans-serif}" +
      P + " .bnT{font-size:15.5px;font-weight:800;color:#235029;line-height:1.3;" +
      "margin:0 0 7px !important;padding:0 !important}" +
      P + " .bnS{font-size:13px;line-height:1.55;color:#5F7060;" +
      "margin:0 0 15px !important;padding:0 !important}" +
      P + " .bnS b{color:#235029}" +
      P + " .bnB{display:block;width:100%;border:none;border-radius:10px;" +
      "margin:0 !important;padding:14px 18px !important;background:#235029;color:#fff;" +
      "font-family:inherit;font-size:15px;font-weight:800;cursor:pointer;" +
      "transition:background .15s}" +
      P + " .bnB:hover{background:#618500}" +
      P + " .bnB[disabled]{opacity:.55;cursor:default}" +
      P + " .bnH{font-size:12.5px;line-height:1.55;color:#5F7060;" +
      "margin:15px 0 0 !important;padding:0 !important}" +
      P + " .bnH b{color:#235029}" +
      P + " .bnM{display:grid;grid-template-columns:auto 1fr;gap:10px;align-items:start;" +
      "border-top:1px solid #E4E0D2;font-size:12.5px;line-height:1.55;color:#5F7060;" +
      "cursor:pointer;margin:15px 0 0 !important;padding:14px 0 0 !important}" +
      P + " .bnM input{width:16px;height:16px;accent-color:#235029;" +
      "margin:2px 0 0 !important;padding:0 !important}" +
      P + " .bnM b{color:#235029}" +
      P + " .bnD{border-top:1px solid #E4E0D2;font-size:12px;line-height:1.55;" +
      "color:#6b7a70;margin:15px 0 0 !important;padding:13px 0 0 !important}";
    document.head.appendChild(s);
  }

  function esc(x) {
    return String(x).replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
    });
  }

  function panel() {
    var el = document.getElementById(PANEL_ID);
    if (el) return el;
    var anchor = document.getElementById("estTotals");
    if (!anchor || !anchor.parentNode) return null;
    el = document.createElement("div");
    el.id = PANEL_ID;
    anchor.parentNode.insertBefore(el, anchor.nextSibling);
    return el;
  }

  function render() {
    if (!ready()) return;
    styles();
    var box = panel();
    if (!box) return;

    /* Over three acres the tool stops quoting, so there is no number to charge
       and nothing to book. */
    if (isCustomLot()) { box.style.display = "none"; return; }

    /* COMMERCIAL - added 2026-10-09 with assets/ss-commercial.js.
       A business is quoted at the commercial mowing rate, and every product in
       the catalog is a residential price. A commercial job also needs a
       certificate of insurance and an invoice to the property manager before
       work starts. So nothing is carted: the panel says why and points at the
       lead form, which carries property_type "commercial" to Carl. */
    if (S.propType === "commercial") {
      box.style.display = "";
      box.innerHTML =
        '<p class="bnT">We set commercial accounts up with you</p>' +
        '<p class="bnS">Business properties get a written price, a certificate of ' +
        "insurance and invoicing to whoever handles your bills, so we confirm the " +
        "quote with you instead of taking payment here.</p>" +
        '<p class="bnS" style="margin:0 !important">Send your quote below and we\'ll ' +
        "follow up to set it up.</p>";
      return;
    }

    var V = window.SS_VARIANTS;
    var wanted = itemsFor(S);
    var held = heldBack(S);

    /* EXACT-SIZE QUOTES - added 2026-10-09.
       Every product in the catalog is priced at its size band's area (Large =
       9,500 sq ft, 1-3 acres = 2 acres, and so on). But a customer who types
       their square footage, traces their lawn on the satellite map, or enters
       their acreage on the 1/2-1 and 1-3 acre cards (assets/ss-acreage.js) is
       quoted at their EXACT size - v19 keeps that in S.acres. On a 1.2-acre lawn
       the screen says one mowing price and the 1-3 acre product charges the
       2-acre one.

       So any line whose exact-size price differs from its band product is not
       carted. It is named and held back like mowing, and confirmed by us. Lines
       that land on the same number either way - common, because the minimums
       are what quote on most lawns - stay bookable. Never "fix" this by carting
       the band product anyway: that is charging a number the customer was not
       shown. */
    var exactSqft = (S.acres != null && S.acres > 0) ? S.acres * 43560 : null;
    var exactLines = [];
    if (exactSqft != null) {
      wanted = wanted.filter(function (w) {
        if (subtotal([w]) === subtotal([w], exactSqft)) return true;
        exactLines.push(lineLabel(w.svc));
        return false;
      });
    }

    /* THE FIRST MOW.
       A season plan is not sellable here - it is a schedule, and out of season
       it is not sellable at all. But a SINGLE visit is a real product at a real
       price on any date of the year, and it is the natural way for someone who
       is not ready to commit to a season to get us onto the property. So when
       mowing is ticked, offer exactly that, opt-in and clearly labelled as one
       visit, rather than folding it into the basket and hoping they read the
       small print. */
    var mowSku = on(S, "mow") ? V.skuFor("mow", S.lot) : null;
    var canFirstMow = !!(mowSku && V.has(mowSku));
    if (canFirstMow && exactSqft != null) {
      var mowLine = [{ svc: "mow", tier: S.lot, qty: 1 }];
      if (subtotal(mowLine) !== subtotal(mowLine, exactSqft)) canFirstMow = false;
    }
    if (exactLines.length) {
      held.push({
        label: exactLines.join(", "),
        why: "These are priced to the exact size you gave us. Online checkout only " +
             "sells our standard size bands, which would charge a different number " +
             "than the one you just saw, so we confirm these and invoice you instead."
      });
    }
    var mowArea = canFirstMow ? tierArea(S.lot) : null;
    var mowEach = mowArea == null ? null
                : window.SS_RATES.round5(window.SS_RATES.mowPerVisit(mowArea / 43560));
    if (!canFirstMow) addFirstMow = false;

    var cart = wanted.slice();
    if (canFirstMow && addFirstMow) cart.push({ svc: "mow", tier: S.lot, qty: 1 });

    /* Resolve every service to a SKU. If the catalog is missing one - a sync
       that has not run, a renamed SKU - do not offer a partial cart. */
    var items = [], i, sku, ok = cart.length > 0;
    for (i = 0; i < cart.length; i++) {
      sku = V.skuFor(cart[i].svc, cart[i].tier);
      if (!sku || !V.has(sku)) { ok = false; break; }
      items.push({ sku: sku, qty: cart[i].qty });
    }
    var url = ok ? V.cartUrl(items) : null;

    if (!url) {
      /* Nothing in the basket. If the reason is that everything they picked is
         held back, say which and why; otherwise stay quiet rather than showing a
         broken button, and let the lead form do its job. */
      if (cart.length === 0 && held.length) {
        box.style.display = "";
        box.innerHTML =
          '<p class="bnT">' + esc(held.length === 1 ? held[0].label + " we set up with you"
                                                    : "We set these up with you") + "</p>" +
          heldHtml(held) +
          (canFirstMow ? firstMowHtml(mowEach, S.svc.mow && S.svc.mow.freq === "biweekly") : "") +
          '<p class="bnS" style="margin:15px 0 0 !important">Send your quote below and ' +
          "we'll get you on the schedule.</p>";
        wireFirstMow();
      } else {
        box.style.display = "none";
      }
      return;
    }

    var total = subtotal(cart);

    box.style.display = "";
    box.innerHTML =
      '<p class="bnT">Ready to book it?</p>' +
      /* The permalink goes straight to checkout on this store rather than to the
         cart page, so the copy says checkout. If the cart page is ever turned
         back on, "takes you to checkout" is still true - it just passes through
         one more screen on the way. */
      '<p class="bnS">Take ' + (items.length === 1 ? "this service" : "these " + items.length + " services") +
      " to checkout" + (total == null ? "" : " — <b>" + money(total) + "</b>") +
      ". Or send the quote and we'll follow up.</p>" +
      '<button type="button" class="bnB" id="ssBookGo">Book now &rarr;</button>' +
      heldHtml(held) +
      (canFirstMow ? firstMowHtml(mowEach, S.svc.mow && S.svc.mow.freq === "biweekly") : "") +
      /* Two separate honesty problems, both worth a sentence.
         (1) The quote is measured from satellite against a size band, so the job
             on the ground can differ.
         (2) The figure on screen is pre-tax, and Wisconsin taxes landscaping
             services - so checkout WILL read higher than the quote. Saying so
             here costs nothing; letting a customer discover it on the payment
             screen costs trust, which is the whole point of quoting honestly in
             the first place. */
      '<p class="bnD">This price is based on the size we measured and what you told us. ' +
      "If the property turns out different once we're standing on it — a gate too narrow " +
      "for the mower, a steep slope, more planting bed than lawn, obstacles we couldn't see " +
      "from above — the price may change slightly. We'll tell you before we start work, " +
      "and we won't charge more without your say-so. Wisconsin sales tax is added at " +
      "checkout.</p>";

    var btn = document.getElementById("ssBookGo");
    if (btn) {
      /* The resolved permalink is also parked on the element. It costs nothing,
         it is how the test harness checks the basket without a real browser, and
         it means anyone can read the exact cart a quote would produce straight
         from devtools instead of having to click through to find out. */
      btn.setAttribute("data-cart", url);
      btn.addEventListener("click", function () {
        btn.disabled = true;
        btn.textContent = "Opening your cart…";
        window.location.href = url;
      });
    }
    wireFirstMow();
  }

  /* A customer-facing name for a cart line, for the exact-size note above. */
  function lineLabel(svc) {
    if (svc === "topdressAeration") return "Topdressing with core aeration + overseeding";
    var c = window.SS_RATES.services[svc];
    return (c && c.label) || svc;
  }

  function heldHtml(held) {
    var out = "", i;
    for (i = 0; i < held.length; i++) {
      out += '<p class="bnH"><b>' + esc(held[i].label) + " stays with us.</b> " +
             esc(held[i].why) + "</p>";
    }
    return out;
  }

  /* The opt-in first visit. Rendered as a real checkbox rather than a second
     button so it reads as part of the mowing explanation above it, and so the
     customer can see the price move before they commit to anything.

     THE BILLING MODEL, STATED HERE BECAUSE THIS IS WHERE THEY DECIDE.
     Carl's arrangement is: pay for the first visit to get started, then every
     visit after it is billed on completion - no contract, nothing taken up
     front - unless they choose to buy a whole season in advance, which only
     goes on sale in spring (see mowing-season-gate.liquid). A customer ticking
     this box is agreeing to one visit, and the two sentences after the price
     are what stop that being a surprise later. */
  function firstMowHtml(each, biweekly) {
    if (each == null) return "";
    return '<label class="bnM"><input type="checkbox" id="ssBookMow"' +
           (addFirstMow ? " checked" : "") + '><span>Want us to start? ' +
           "<b>Add your first mow — " + money(each) + "</b>. That's one visit, booked " +
           "now. Every mow after it is billed when we finish it, on your " +
           (biweekly ? "every-other-week" : "weekly") + " schedule — no contract, " +
           "nothing else charged today. Prefer to pay up front? Full-season plans go " +
           "on sale in March.</span></label>";
  }

  function wireFirstMow() {
    var cb = document.getElementById("ssBookMow");
    if (!cb) return;
    cb.addEventListener("change", function () {
      addFirstMow = !!cb.checked;
      try { render(); } catch (e) {}
    });
  }

  /* The quote redraws on every click in the tool. v19 funnels all of that through
     calc(), so wrapping it once keeps the panel in step without polling. */
  function hook() {
    if (typeof window.calc === "function" && !window.calc.__ssBookWrapped) {
      var orig = window.calc;
      var wrapped = function () {
        var r = orig.apply(this, arguments);
        try { render(); } catch (e) {}
        return r;
      };
      wrapped.__ssBookWrapped = true;
      window.calc = wrapped;
      return true;
    }
    return false;
  }

  /* COMING BACK TO THE PAGE.
     Clicking Book now disables the button and changes its label to "Opening your
     cart…" - correct while the browser is navigating away. But press Back, or
     return from checkout, and the browser restores this page from its cache
     exactly as it was left: a dead grey button that still says it is opening.
     pageshow fires on both a fresh load and a cache restore, and render()
     rebuilds the panel from scratch, so the button comes back alive. */
  window.addEventListener("pageshow", function () {
    try { render(); } catch (e) {}
  });

  /* ss-variants.js, ss-rates.js and v19 are all deferred, so they have normally
     finished by now. Retry briefly in case script order ever changes, then give
     up quietly - a missing Book Now button costs a convenience, not a lead, and
     the quote and its form are untouched either way. */
  var tries = 0;
  var t = setInterval(function () {
    if (ready() && hook()) {
      clearInterval(t);
      try { render(); } catch (e) {}
      return;
    }
    if (++tries > 80) {
      clearInterval(t);
      if (!window.SS_VARIANTS) {
        console.warn("Sunny Stripes: assets/ss-variants.js did not load; Book Now is off.");
      }
    }
  }, 50);
})();
